import auth from './auth';
import layout from './layout';
import message from './message';
import manager from './manager';
import club from './club';
import city_events from './city_events';
import fanBoxMessages from './fanBoxMessages';
import settings from './settings';
import news from './news';
import participant from './participant';
import player from './player';
import event from './event';
import shop from './shop';
import clubCms from './club-cms';
import promotion from './promotion';
import banner from './banner';
import customStream from './stream/customStream';
import liveStadiumStream from './stream/liveStadiumStream';
import vod from './vod';
import countries from './countries';
import streamVideo from './stream-video';
import clubSettings from './club-settings';
import video_categories from './video-categories';
import competition from './competition';
import fan_feed_posts from './fan_feed/fan_feed_posts';
import fan_feed_tags from './fan_feed/fan_feed_tags';
import fan_feed_slideshow from './fan_feed/fan_feed_slideshow';
import shop_stripe from './shop_stripe';

export default {
  auth,
  layout,
  message,
  manager,
  club,
  city_events,
  fanBoxMessages,
  settings,
  news,
  participant,
  player,
  event,
  shop,
  clubCms,
  promotion,
  banner,
  customStream,
  liveStadiumStream,
  vod,
  countries,
  streamVideo,
  clubSettings,
  video_categories,
  competition,
  fan_feed_posts,
  fan_feed_tags,
  fan_feed_slideshow,
  shop_stripe,
}


// WEBPACK FOOTER //
// ./src/reducers/index.js